<script lang="ts" setup>
import type { Cta } from "@interfaces/Cta.ts";
import type { PropType } from "vue";
import { ref, computed, toRef } from "vue";
import Accordion from "@/components/Accordion.vue";
import { Head } from "@inertiajs/vue3";
import { useFaqPageSchema } from "@/helpers/composables/useFaqPageSchema";

interface Faq {
    question: string;
    answer: string;
    category: string;
}

interface FaqCollection {
    headline: string;
    cta?: Cta;
    faqs: Faq[];
}

const props = defineProps({
    faqs: {
        type: Array as PropType<Faq[]>,
        required: true,
    },
});

const { schemaJson } = useFaqPageSchema(toRef(props, "faqs"));

let faqsAccordionDetails = computed(()=>{
    let map = new Map<string, Faq[]>();
    props.faqs.forEach((faq)=>{
        //check faqSearchValue
        if(faqSearchValue.value != ""){
            if( (faq.question.toLowerCase().includes(faqSearchValue.value.toLowerCase()) || faq.answer.toLowerCase().includes(faqSearchValue.value.toLowerCase()) || faq.category.toLowerCase().includes(faqSearchValue.value.toLowerCase()))){
                if(map.has(faq.category)){
                    map.get(faq.category)?.push({
                        title: faq.question,
                        content: faq.answer
                    });
                }else{
                    map.set(faq.category, [{
                        title: faq.question,
                        content: faq.answer
                    }]);
                }
            }
        }
        else {
            if(map.has(faq.category)){
                map.get(faq.category)?.push({
                    title: faq.question,
                    content: faq.answer
                });
            }else{
                map.set(faq.category, [{
                    title: faq.question,
                    content: faq.answer
                }]);
            }
        }
    });
    return map;
});

let faqSearchValue = ref('');

</script>
<template>

    <div>
        <Head>
            <title>Tactical Insights to Rothco's FAQS</title>
            <meta name="description" content="Frequently Ask Questions about Rothco's product line and insights into our daily operations." />
            <component
                v-if="schemaJson"
                :is="'script'"
                type="application/ld+json"
                head-key="faq-page-schema"
            >{{ schemaJson }}</component>
        </Head>
        <h2 class="headline-xl">FAQs</h2>
        <div class="faqs-search">
            <div class="input-folder">
                <div class="input-folder--input">
                    <PrimeInputText placeholder="" id="faqSearch" v-model.lazy="faqSearchValue"/>
                    <label for="faqSearch">
                        <p class="paragraph-default">
                            Search for a topic or question
                        </p>
                    </label>
                </div>
            </div>
        </div>
        <hr v-if="faqsAccordionDetails.size > 0">
        <div class="faqs-container" v-for="[key, value] in faqsAccordionDetails" :key="key">
            <Accordion :headline="key" :accordion-details="value"></Accordion>
        </div>
        <div v-if="faqsAccordionDetails.size == 0">
            <h2 id="no-results-text" class="headline-xl results-header text-center faqs-no-results">
                No Results Found
            </h2>
        </div>
    </div>
</template>